import { render, staticRenderFns } from "./MobileGetAppBanner.vue?vue&type=template&id=52fc6fbe&scoped=true"
import script from "./MobileGetAppBanner.vue?vue&type=script&lang=js"
export * from "./MobileGetAppBanner.vue?vue&type=script&lang=js"
import style0 from "./MobileGetAppBanner.vue?vue&type=style&index=0&id=52fc6fbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52fc6fbe",
  null
  
)

export default component.exports